import { render } from "./AppInputFecha.vue?vue&type=template&id=38bed3b8&scoped=true"
import script from "./AppInputFecha.vue?vue&type=script&lang=ts"
export * from "./AppInputFecha.vue?vue&type=script&lang=ts"

import "./AppInputFecha.vue?vue&type=style&index=0&id=38bed3b8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-38bed3b8"

export default script